import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import bind from "memoize-bind";

import { st, SubBar, MainView, AgentCooperationsList, Button, FormControl, PaginationNavigation, Message } from "lib/index";
import { pushCompanyRoute } from "modules/app/actions";
import openNewAgentPrompt from "modules/agents/NewAgentPrompt/NewAgentPrompt";
import { stateSelector, initializeView, destroyView, fetchRecords, changePagination, setSearch } from "./index";

@connect(
  (state) => ({
    records: stateSelector(state).records.model,
    fetchDone: stateSelector(state).records.fetchDone,
    fetchLoading: stateSelector(state).records.fetchLoading,
    fetchFailed: stateSelector(state).records.fetchFailed,
    offset: stateSelector(state).offset,
    limit: stateSelector(state).limit,
    search: stateSelector(state).search,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        initializeView,
        destroyView,
        fetchRecords,
        pushCompanyRoute,
        changePagination,
        setSearch,
      },
      dispatch
    )
)
export default class AgentsListView extends React.PureComponent {
  componentDidMount() {
    this.props.initializeView();
  }

  componentWillUnmount() {
    this.props.destroyView();
  }

  handleNewAgentClick() {
    const { pushCompanyRoute } = this.props;
    openNewAgentPrompt().then((coop) => {
      pushCompanyRoute(`/agents/${coop.id}`);
    });
  }

  render() {
    const { records, fetchDone, fetchLoading, fetchFailed, fetchRecords, offset, limit, search, changePagination, setSearch } = this.props;
    const items = (records && records.records) || [];
    const totalCount = (records && records.meta && records.meta.total_count) || 0;

    return (
      <MainView.Container>
        <SubBar>
          <div className="pull-left u-inlineFlexRow">
            <h1>{I18n.t("papp.agents.AgentsListView.title")}</h1>
            <FormControl.Input
              value={search}
              onChange={(query) => setSearch(query)}
              placeholder={I18n.t("papp.common.search")}
              className="u-marginLeft c-inputStandard"
            />
          </div>

          <div className="pull-right u-inlineFlexRow">
            {fetchDone && totalCount > 0 && (
              <PaginationNavigation
                offset={offset}
                limit={limit}
                totalCount={totalCount}
                onChange={changePagination}
                name="agentsLimit"
              />
            )}
            {st.authorize.company.enable_saas &&
              st.authorize("create", { type: "AgentCooperation", supplier: st.authorize.company, agent: {} }) && (
                <Button primary as="a" className="u-marginLeft" onClick={bind(this.handleNewAgentClick, this)}>
                  {I18n.t("papp.agents.AgentsListView.add_new")}
                </Button>
              )}
          </div>
        </SubBar>
        <MainView.Content grayBackground hasSubBar>
          <MainView.Dimmer loading={fetchLoading} failed={fetchFailed} retry={fetchRecords} />
          {fetchDone && totalCount === 0 && !search && (
            <MainView.DimmerContent
              icon="sentiment_neutral"
              title={I18n.t("papp.agents.AgentsListView.no_records_title")}
            >
              <p>
                {I18n.t("papp.agents.AgentsListView.no_records_message")}{" "}
                <a className="u-cursorPointer" onClick={bind(this.handleNewAgentClick, this)}>
                  {I18n.t("papp.agents.AgentsListView.no_records_add_new_link")}
                </a>
              </p>
            </MainView.DimmerContent>
          )}
          {fetchDone && items.length === 0 && search && (
            <Message>{I18n.t("papp.common.no_results_message")}</Message>
          )}
          {fetchDone && items.length > 0 && (
            <AgentCooperationsList records={items} />
          )}
        </MainView.Content>
      </MainView.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/agents/AgentsListView/AgentsListView.jsx